export const GET_HERO_DATA_DETAILS_REQUEST = "GET_HERO_DATA_DETAILS_REQUEST";
export const GET_HERO_DATA_DETAILS_SUCCESS = "GET_HERO_DATA_DETAILS_SUCCESS";
export const GET_HERO_DATA_DETAILS_FAIL = "GET_HERO_DATA_DETAILS_FAIL";
export const GET_HERO_DATA_DETAILS_RESET = "GET_HERO_DATA_DETAILS_RESET";

export const ADD_HERO_DATA_DETAILS_REQUEST = "ADD_HERO_DATA_DETAILS_REQUEST";
export const ADD_HERO_DATA_DETAILS_SUCCESS = "ADD_HERO_DATA_DETAILS_SUCCESS";
export const ADD_HERO_DATA_DETAILS_FAIL = "ADD_HERO_DATA_DETAILS_FAIL";
export const ADD_HERO_DATA_DETAILS_RESET = "ADD_HERO_DATA_DETAILS_RESET";

export const SAVE_AUDIENCE_DATA_REQUEST = "SAVE_AUDIENCE_DATA_REQUEST";
export const SAVE_AUDIENCE_DATA_SUCCESS = "SAVE_AUDIENCE_DATA_SUCCESS";
export const SAVE_AUDIENCE_DATA_FAIL = "SAVE_AUDIENCE_DATA_FAIL";
export const SAVE_AUDIENCE_DATA_RESET = "SAVE_AUDIENCE_DATA_RESET";

export const GET_AUDIENCE_DATA_REQUEST = "GET_AUDIENCE_DATA_REQUEST";
export const GET_AUDIENCE_DATA_SUCCESS = "GET_AUDIENCE_DATA_SUCCESS";
export const GET_AUDIENCE_DATA_FAIL = "GET_AUDIENCE_DATA_FAIL";
